export default "__VITE_ASSET__Bcrd5Go___"